import { createContext, Dispatch, SetStateAction, useState, useContext } from 'react';
import { BFObject } from "../types/bfObject"
import { IProps } from "../types/props"

export interface ICliente extends BFObject {}

interface IPropsClienteContext {
    cliente: ICliente,
    setCliente: Dispatch<SetStateAction<ICliente>>,
}

const ClienteContext = createContext<IPropsClienteContext>({ cliente: novoCliente() } as IPropsClienteContext);

const ClienteProvider = ({ children }: IProps) => {
    const [cliente, setCliente] = useState<ICliente>(novoCliente());

    return (<ClienteContext.Provider value={{
        cliente,
        setCliente
    }}>
        {children}
    </ClienteContext.Provider>)
};

export function useCliente(): [ICliente, Dispatch<SetStateAction<ICliente>>] {
    const context = useContext(ClienteContext);
    const { cliente, setCliente } = context;
    return [cliente, setCliente];
}

export function novoCliente(): ICliente {

    return {
        id: "",
    }
}

export { ClienteContext, ClienteProvider };